import { X, HelpCircle, Link as LinkIcon, ChevronRight } from 'lucide-react';

export default function UrlGuideOverlay({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      <div
        className="relative bg-white w-full sm:max-w-md sm:rounded-2xl rounded-t-2xl max-h-[85vh] overflow-y-auto shadow-2xl animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-100 px-5 py-4 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-accent-blue" />
            <h2 className="font-bold text-brand-navy text-lg">Comment faire ?</h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center active:scale-90 transition-transform">
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>

        <div className="px-5 py-6 space-y-4">
          <div className="flex items-center gap-2 text-brand-navy font-semibold">
            <LinkIcon className="w-5 h-5" />
            <span>Vérifier un lien (URL)</span>
          </div>

          <ol className="space-y-4">
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 bg-accent-blue/10 text-accent-blue rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">1</span>
              <span className="text-sm text-text-primary leading-relaxed">Trouvez le lien suspect dans votre application (SMS, WhatsApp, Navigateur...).</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 bg-accent-blue/10 text-accent-blue rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">2</span>
              <span className="text-sm text-text-primary leading-relaxed">Appuyez longtemps sur le lien et choisissez <strong>Copier</strong> (ou Copier l'URL).</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-6 h-6 bg-accent-blue/10 text-accent-blue rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">3</span>
              <span className="text-sm text-text-primary leading-relaxed">Revenez ici et collez le lien dans le champ de saisie.</span>
            </li>
          </ol>
        </div>

        <div className="mx-5 mb-5 p-3 bg-blue-50 border border-blue-200 rounded-xl">
          <p className="text-xs text-blue-800 leading-relaxed">
            <strong>💡 Astuce :</strong> Ne cliquez pas sur le lien pour le copier. Maintenez toujours votre doigt enfoncé pour ouvrir le menu d'options sans visiter le site dangereux.
          </p>
        </div>

        <div className="sticky bottom-0 bg-white border-t border-gray-100 px-5 py-4">
          <button onClick={onClose} className="w-full btn-primary">
            J'ai compris <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
